var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-index",attrs:{"id":"app"}},[(_vm.user && _vm.user.id)?_c('navbar'):_vm._e(),_c('router-view'),(_vm.processing)?_c('block-ui'):_vm._e(),_c('footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }